import type { CivilianDefinition, CivilianStop, CivilianWalk, Point } from './world-types.js';

/** Seconds one round of a walk takes: every stop's wait and every leg's walk, the last leg back to the first stop. */
export function civilianRoundSeconds(walk: CivilianWalk): number {
  const { stops, speed } = walk;
  return stops.reduce((total, stop, i) => { const next = stops[(i + 1) % stops.length]; return total + stop.seconds + Math.hypot(next.x - stop.x, next.z - stop.z) / speed; }, 0);
}

/**
 * Where a civilian is at `seconds` of game time, and the stop it stands at (none while it walks). A resident without a walk is always at its
 * place. A walker starts its round at its first stop, `phaseSeconds` in, so neighbours on one round keep apart.
 */
export function civilianPlace(civilian: CivilianDefinition, seconds: number): Point & { stop?: CivilianStop } {
  const walk = civilian.walk;
  if (!walk || walk.stops.length < 2) return { x: civilian.x, z: civilian.z };
  const round = civilianRoundSeconds(walk);
  let t = ((seconds + civilian.phaseSeconds) % round + round) % round;
  for (let i = 0; i < walk.stops.length; i++) {
    const stop = walk.stops[i], next = walk.stops[(i + 1) % walk.stops.length];
    if (t < stop.seconds) return { x: stop.x, z: stop.z, stop };
    t -= stop.seconds;
    const leg = Math.hypot(next.x - stop.x, next.z - stop.z) / walk.speed;
    if (t < leg) { const share = t / leg; return { x: stop.x + (next.x - stop.x) * share, z: stop.z + (next.z - stop.z) * share }; }
    t -= leg;
  }
  return { x: walk.stops[0].x, z: walk.stops[0].z, stop: walk.stops[0] };
}
